import { ZeroProvider } from "@rocicorp/zero/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { decodeJwt } from "jose";

import { Auth } from "@/components/auth";
import { checkAuthFn } from "@/features/auth/server-functions/check-auth";
import { getAccessTokenFn } from "@/features/auth/server-functions/get-access-token";
import { useTelegramBackButton } from "@/hooks/telegram/use-back-button";
import { useDisabledVerticalSwipe } from "@/hooks/telegram/use-disabled-vertical-swipe";
import { useTelegramTheme } from "@/hooks/telegram/use-telegram-theme";
import { initZero } from "@/lib/zero";

export const Route = createFileRoute("/_app")({
  component: RouteComponent,
  context: () => {
    const encodedJWT = getAccessTokenFn();
    const decodedJWT = encodedJWT && decodeJwt(encodedJWT);
    const userId = decodedJWT?.sub ? (decodedJWT.sub as string) : "anon";

    const zero = initZero(userId, encodedJWT ?? "");

    if (import.meta.env.DEV && typeof window !== "undefined") {
      (window as unknown as { zero: typeof zero }).zero = zero;
    }

    return { zero };
  },
  beforeLoad: async () => {
    const auth = await checkAuthFn();
    return { auth };
  },
});

function RouteComponent() {
  useTelegramTheme();
  useTelegramBackButton();
  useDisabledVerticalSwipe();

  const { auth, zero } = Route.useRouteContext();
  return (
    <ZeroProvider zero={zero}>
      {auth.authenticated ? <Outlet /> : <Auth />}
    </ZeroProvider>
  );
}
